import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@tn-equis/core/components/ripple';
import { EquisRippleModule } from '@tn-equis/core/components/ripple';
import { EquisBadgesModule } from '@tn-equis/core/components/badges';

class EquisCardComponent {
    constructor() {
        this.clickable = false;
        this.hover = false;
        this.cardEvents = new EventEmitter();
        this.rippleBackgroundColor = 'rgba(0, 0, 0, 0.16)';
    }
    emitEvent() {
        if (this.clickable) {
            this.cardEvents.emit();
        }
    }
}
EquisCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisCardComponent, selector: "z-card, equis-card", inputs: { clickable: "clickable", hover: "hover" }, outputs: { cardEvents: "cardEvents" }, ngImport: i0, template: "<div\n  equisRipple\n  [rippleDisabled]=\"!clickable\"\n  [rippleBackgroundColor]=\"rippleBackgroundColor\"\n  (click)=\"emitEvent()\"\n  class=\"card-container\"\n  [ngClass]=\"{\n    'card-container--hover': hover,\n    'card-container--ripple': clickable\n  }\"\n>\n  <ng-content select=\"equis-badge, equis-status-badge\"></ng-content>\n  <ng-content></ng-content>\n</div>\n", styles: [".card-container{background-color:#fff;border:1px solid rgba(232,232,232,.7);border-radius:16px;box-shadow:0 2px 4px #00000014;position:relative;transition:all .2s ease-in-out;width:100%}.card-container--hover:hover{box-shadow:0 8px 16px #0000001f,0 -4px 16px -4px #00000014;cursor:pointer}.card-container--ripple{overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.EquisRippleDirective, selector: "[zRipple], [equisRipple]", inputs: ["rippleBackgroundColor", "rippleClassBackgroundColor", "rippleDisabled"], exportAs: ["zRipple", "equisRipple"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-card, equis-card', template: "<div\n  equisRipple\n  [rippleDisabled]=\"!clickable\"\n  [rippleBackgroundColor]=\"rippleBackgroundColor\"\n  (click)=\"emitEvent()\"\n  class=\"card-container\"\n  [ngClass]=\"{\n    'card-container--hover': hover,\n    'card-container--ripple': clickable\n  }\"\n>\n  <ng-content select=\"equis-badge, equis-status-badge\"></ng-content>\n  <ng-content></ng-content>\n</div>\n", styles: [".card-container{background-color:#fff;border:1px solid rgba(232,232,232,.7);border-radius:16px;box-shadow:0 2px 4px #00000014;position:relative;transition:all .2s ease-in-out;width:100%}.card-container--hover:hover{box-shadow:0 8px 16px #0000001f,0 -4px 16px -4px #00000014;cursor:pointer}.card-container--ripple{overflow:hidden}\n"] }]
        }], propDecorators: { clickable: [{
                type: Input
            }], hover: [{
                type: Input
            }], cardEvents: [{
                type: Output
            }] } });

class EquisCardModule {
    static forRoot() {
        return {
            ngModule: EquisCardModule,
        };
    }
}
EquisCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisCardModule, declarations: [EquisCardComponent], imports: [CommonModule, EquisRippleModule, EquisBadgesModule], exports: [EquisCardComponent] });
EquisCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCardModule, imports: [CommonModule, EquisRippleModule, EquisBadgesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisCardComponent],
                    imports: [CommonModule, EquisRippleModule, EquisBadgesModule],
                    exports: [EquisCardComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EquisCardComponent, EquisCardModule };
